define('modules/common/service/Studio',[], function() {
	var Studio = function($http, $q, PATH, LoadingHandler) {
		var useralias = '';
		var datistudio = false;

		var load = function() {
			var deferred = $q.defer();
			LoadingHandler.start();
			$http({
				method: 'GET',
				url: 'https://' + PATH.DNSENTRYPOINT + '/idstudio',
				cache: false,
				params: {
					alias: useralias
				}
			}).then(
				function(response) {
					datistudio = response.data;
					deferred.resolve();
					LoadingHandler.stop();
				},
				function(error) {
					deferred.reject({
						status: error.status,
						data: error.data
					});
					LoadingHandler.stop();
				});

			return deferred.promise;
		};

		var execAfterContentIsLoaded = function() {
			var deferred = $q.defer();
			if (datistudio.id) {
				deferred.resolve();
			} else {
				load().then(function() {
					deferred.resolve();
				}, function(error) {
					deferred.reject(error);
				});
			}
			return deferred.promise;
		};

		return {
			load: load,
			setAlias: function(alias) {
				datistudio = false;
				useralias = alias;
			},
			getId: function() {
				return execAfterContentIsLoaded().then(function() {
					return datistudio.id;
				});

			},
			getAlias: function() {
				return useralias;
			}
		};
	};

	return ["$http", "$q", "PATH", "LoadingHandler", Studio];
});
